import { Helmet } from "react-helmet-async";

const SITE_URL = "https://wm-erneuerbareenergien.com";
const DEFAULT_IMAGE = `${SITE_URL}/images/social-preview.webp`;
const ORG_AUTHOR = "WM Erneuerbare Energien GmbH";

interface SeoProps {
  title: string;
  description: string;
  path: string;
  image?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  /** og:type — Standard ist "website", für Aktuelles-Artikel "article". */
  type?: "website" | "article";
  /** Pflicht für article: ISO-8601-Datum oder yyyy-mm-dd. */
  publishedTime?: string;
  /** Optional für article. */
  modifiedTime?: string;
  /** Optional für article — Autor-Name. Default: WMEE-Organisation. */
  author?: string;
}

const Seo = ({
  title,
  description,
  path,
  image,
  jsonLd,
  type = "website",
  publishedTime,
  modifiedTime,
  author,
}: SeoProps) => {
  const url = `${SITE_URL}${path}`;
  const ogImage = image ?? DEFAULT_IMAGE;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  const isArticle = type === "article";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {isArticle && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {isArticle && (modifiedTime || publishedTime) && (
        <meta property="article:modified_time" content={modifiedTime ?? publishedTime!} />
      )}
      {isArticle && (
        <meta property="article:author" content={author ?? ORG_AUTHOR} />
      )}
      {isArticle && (
        <meta property="article:section" content="Aktuelles" />
      )}
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
